import { z } from 'zod';

export const ErrorSchema = z.object({
  type: z.string(),
  message: z.string(),
  validation_errors: z
    .object({
      loc: z.tuple([z.string(), z.number()]),
      msg: z.string(),
      type: z.string(),
    })
    .nullable(),
  code: z.number(),
});

export const createResponseSchema = <D extends z.ZodType, A extends z.ZodType>(
  data: D,
  additional?: A,
) => {
  return z.object({
    data: z
      .object({
        items: z.array(data),
        message: z.string().nullable(),
        pageNumber: z.number().nullable(),
        itemsPerPage: z.number().nullable(),
        totalItems: z.number().nullable(),
        ordering: z.string().nullable(),
        additional: additional ?? z.null(),
      })
      .nullable(),
    error: ErrorSchema.nullable(),
  });
};

export const baseResponseSchema = createResponseSchema(z.any());

export const isValidNonGet500Error = (error: unknown) => {
  return (
    // check that it exists
    (typeof error === 'object' &&
      error &&
      // check that it's 500
      'status' in error &&
      typeof error.status === 'number' &&
      error.status >= 500 &&
      // check that it non-get
      'config' in error &&
      typeof error.config === 'object' &&
      error.config &&
      'method' in error.config &&
      error.config.method !== 'get') === true // eq true to prevent boolean | null
  );
};
